export const ALL_TEST_REQUEST = 'ALL_TEST_REQUEST'
export const ALL_TEST_SUCCESS = 'ALL_TEST_SUCCESS'
export const ALL_TEST_FAIL = 'ALL_TEST_FAIL'